module.exports = __webpack_public_path__ + "static/media/5v5ideLogoWhite.689105b6.png";